import React from "react";

import * as styles from "./styles.module.css";

export function Logo() {
    return <div data-testid="logo" className={styles.logo} aria-label="Smartling" />;
}
